// import React, { useState, useEffect, useContext } from 'react';  //new
// import { useNavigate } from 'react-router-dom';  //new
// import { UserContext } from './userContext';  //new
// import {
//     Paper,
//     Typography,
//     TextField,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     Button,
// } from '@mui/material';
// import { makeStyles } from '@mui/styles';
// import { backendUrl } from './config';
// import AddressCheck from './checkAddress';
// import { sendEmail } from './sendEmail';

// const useStyles = makeStyles(() => ({
//     formContainer: {
//         padding: 32,
//         maxWidth: 400,
//         margin: 'auto',
//         backgroundColor: '#fff',
//         boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//         borderRadius: 8,
//     },
//     formField: {
//         marginBottom: '3px !important',
//         width: '100%',
//     },
//     submitButton: {
//         marginTop: 16,
//         width: '100%',
//         display: 'block',
//         backgroundColor: '#4b9ef1 !important',
//         color: '#fff !important',
//     },
// }));

// const Signup = () => {
//     const classes = useStyles();
//     const { updateUser } = useContext(UserContext);  // new
//     const navigate = useNavigate();   // New

//     const [usertype, setUsertype] = useState("client");
//     const [username, setUsername] = useState("");
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const [name, setName] = useState("");
//     const [companyName, setCompanyName] = useState("");
//     const [position, setPosition] = useState("");
//     const [phoneNumber, setPhoneNumber] = useState("");
//     const [serviceProvider, setServiceProvider] = useState(null);

//     const [message, setMessage] = useState("");
//     const [confirmSPCreation, setConfirmSPCreation] = useState(false);
//     const [isCreatingServiceProvider, setIsCreatingServiceProvider] = useState(false);

//     const [addressDetails, setAddressDetails] = useState({
//         building: "",
//         apt: "",
//         city: "",
//         state: "",
//         zip: "",
//         lat: null,
//         lon: null,
//     });

//     const [showAddressFields, setShowAddressFields] = useState(false);
//     // const [serviceProviders, setServiceProviders] = useState([]);
//     const [selectedServiceProviderId, setSelectedServiceProviderId] = useState("");
//     const [serviceProviderInput, setServiceProviderInput] = useState("");
//     const [serviceProviders, setServiceProviders] = useState([]);  // still fetch list for lookup


//     // NEW: State for Tasker / Dispatcher input and fetched taskers
//     const [taskerInput, setTaskerInput] = useState("");
//     const [taskers, setTaskers] = useState([]);

//     useEffect(() => {
//         // For client and manager, fetch available service providers
//         if (["client", "manager"].includes(usertype)) {
//             async function fetchServiceProviders() {
//                 try {
//                     const res = await fetch(`${backendUrl}/service-providers`);
//                     if (!res.ok) throw new Error("Failed to fetch service providers");
//                     const data = await res.json();
//                     setServiceProviders(data);
//                     if (usertype === "client" && data.length > 0) {
//                         const sp = data[0];
//                         const spId = sp._id.toString();
//                         setSelectedServiceProviderId(spId);
//                         setServiceProvider({ _id: spId, name: sp.companyName });
//                     }
//                 } catch (err) {
//                     console.error(err);
//                 }
//             }
//             fetchServiceProviders();
//         }
//     }, [usertype]);

//     // Fetch taskers when usertype is subcontractor (implementer)
//     useEffect(() => {
//         if (usertype === "subcontractor") {
//             async function fetchTaskers() {
//                 try {
//                     const res = await fetch(`${backendUrl}/taskers`);
//                     if (!res.ok) throw new Error("Failed to fetch taskers");
//                     const data = await res.json();
//                     setTaskers(data);
//                 } catch (err) {
//                     console.error(err);
//                 }
//             }
//             fetchTaskers();
//         }
//     }, [usertype]);

//     const getAddressPayload = () => ({
//         ...addressDetails,
//         apt: addressDetails.apt || "",
//     });

//     const handleSignup = async (e) => {
//         e.preventDefault();

//         // Clear any previous confirmations if reselecting a user type.
//         if (confirmSPCreation && selectedServiceProviderId) {
//             setConfirmSPCreation(false);
//         }

//         if (password.length < 8) {
//             setMessage("Password must be at least 8 characters long.");
//             return;
//         }

//         // Use "implementer" internally for subcontractor
//         const effectiveUserType = usertype === "subcontractor" ? "implementer" : usertype;
//         const effectiveName = usertype === "client" ? username : (name.trim() ? name.trim() : email.trim());

//         // Build the base payload for all user types
//         const payload = {
//             usertype: effectiveUserType,
//             accountSource: 'otherFrontend',    
//             username,
//             email,
//             password,
//             name: effectiveName,
//             position,
//             phoneNumber,
//             address: getAddressPayload(),
//         };

//         // Implementer-specific Tasker matching logic
//         // if (effectiveUserType === "implementer") {
//         //     let currentTaskers = taskers;
//         //     try {
//         //         const res = await fetch(`${backendUrl}/taskers`);
//         //         if (!res.ok) throw new Error("Failed to fetch taskers");
//         //         currentTaskers = await res.json();
//         //         setTaskers(currentTaskers);
//         //     } catch (error) {
//         //         console.error("Error fetching taskers:", error);
//         //         currentTaskers = [];
//         //     }
//         //     const matchedTasker = currentTaskers.find((t) => t.username === taskerInput);
//         //     const taskerObj = matchedTasker
//         //         ? { username: matchedTasker.username, id: matchedTasker._id }
//         //         : { username: taskerInput, id: '0000000000000000' };
//         //     payload.criteria = { tasker: [taskerObj] };
//         // }

//             if (effectiveUserType === "implementer") {
//     if (taskerInput.trim()) {
//         let currentTaskers = taskers;
//         try {
//             const res = await fetch(`${backendUrl}/taskers`);
//             if (!res.ok) throw new Error("Failed to fetch taskers");
//             currentTaskers = await res.json();
//             setTaskers(currentTaskers);
//         } catch (error) {
//             console.error("Error fetching taskers:", error);
//             currentTaskers = [];
//         }
//         const matchedTasker = currentTaskers.find((t) => t.username === taskerInput);
//         payload.criteria = { tasker: matchedTasker ? [matchedTasker._id] : [] };
//     } else {
//         payload.criteria = { tasker: [] };
//     }
// }

//         // For client and manager, attach a service provider from the dropdown.
//         // if (usertype === "manager" || usertype === "client") {
//         //     if (usertype === "manager" && !serviceProvider) {
//         //         setMessage("Please select a service provider.");
//         //         return;
//         //     }
//         //     if (usertype === "client") {
//         //         if (selectedServiceProviderId) {
//         //             const selectedSP = serviceProviders.find(
//         //                 (sp) => sp._id.toString() === selectedServiceProviderId
//         //             );
//         //             payload.serviceProviders = selectedSP
//         //                 ? [{ _id: selectedServiceProviderId, name: selectedSP.companyName }]
//         //                 : [{ _id: "0", name: "N/A" }];
//         //         } else {
//         //             payload.serviceProviders = [{ _id: "0", name: "N/A" }];
//         //         }
//         //     } else {
//         //         payload.serviceProviders = [serviceProvider];
//         //     }
//         // }

// // For client and manager, lookup by typed SP name and attach by ID
//         // if (["client", "manager"].includes(usertype)) {
//         //        const name = serviceProviderInput.trim();
//         //         if (!name) {
//         //             setMessage("Please enter a service provider name.");
//         //             return;
//         //         }
//         //         // find exact (case-insensitive) match in fetched list
//         //         const match = serviceProviders.find(
//         //             sp => sp.companyName.toLowerCase() === name.toLowerCase()
//         //         );
//         //         if (!match) {
//         //             setMessage(`No service provider named "${name}" found.`);
//         //             return;
//         //         }
//         //    // attach both to criteria and payload
//         //         payload.criteria = {
//         //            ...(payload.criteria || {}),
//         //             serviceProvider: [ match._id ]
//         //         };
//         //         payload.serviceProviders = [{
//         //             _id: match._id,
//         //             name: match.companyName
//         //         }];
//         //     }


//         // For client & manager: match the typed SP name, else show tailored alert
//         // Clients may leave it blank; managers must supply a valid SP
//         // if (["client", "manager"].includes(usertype)) {
//         //         const input = serviceProviderInput.trim();
//         //         const match = serviceProviders.find(
//         //            sp => sp.companyName.toLowerCase() === input.toLowerCase()
//         //         );
    
//         //         if (usertype === "manager") {
//         //             // For managers: input must be nonempty and match
//         //             if (!input || !match) {
//         //                 alert(
//         //                   "Service provider not available. Please contact the service provider to confirm the correct name. " +
//         //                   "If you are the service provider, please register as a General Manager, create your company profile, " +
//         //                   "and add managers afterward."
//         //                 );
//         //                 return; // block registration
//         //             }
//         //         } else {
//         //             // For clients: only warn if they actually typed something invalid
//         //             if (input && !match) {
//         //                 alert(
//         //                   "Service provider not available. Please contact the service provider to confirm the correct name. " +
//         //                   "If none exists, leave it blank and we will assist with assigning one."
//         //                 );
//         //             }
//         //        }
    
//         //         // Only attach if we found a match
//         //         if (match) {
//         //            payload.criteria = {
//         //                ...(payload.criteria || {}),
//         //                 serviceProvider: [match._id]
//         //            };
//         //            payload.serviceProviders = [{
//         //                 _id: match._id,
//         //                 name: match.companyName
//         //             }];
//         //         }
//         //     }

//         // if (["client", "manager"].includes(usertype)) {
//         //                 const name = serviceProviderInput.trim();
//         //                 const match = serviceProviders.find(
//         //                     sp => sp.companyName.toLowerCase() === name.toLowerCase()
//         //                 );
//         //                 if (!match) {
//         //                     if (usertype === "client") {
//         //                         alert(
//         //                           "Service provider not available. Please contact the service provider to confirm the correct name. " +
//         //                           "If none exists, leave it blank and we will assist with assigning one."
//         //                         );
//         //                         // ensure we don't send any criteria or SP array
//         //                         delete payload.criteria;
//         //                         delete payload.serviceProviders;
//         //                     } else {
//         //                         alert(
//         //                           "Service provider not available. Please contact the service provider to confirm the correct name. " +
//         //                           "If you are the service provider, please register as a General Manager, create your company profile, " +
//         //                           "and add managers afterward."
//         //                         );
//         //                         return; // block registration for managers
//         //                     }
//         //                 } else {
//         //                     // attach both to criteria and payload when matched
//         //                     payload.criteria = {
//         //                        ...(payload.criteria || {}),
//         //                         serviceProvider: [match._id]
//         //                     };
//         //                     payload.serviceProviders = [{
//         //                         _id: match._id,
//         //                         name: match.companyName
//         //                     }];
//         //                 }
//         //             }




//         if (["client","manager"].includes(usertype)) {
//                         const input = serviceProviderInput.trim();
//                        const match = serviceProviders.find(
//                             sp => sp.companyName.toLowerCase() === input.toLowerCase()
//                         );
            
//                         if (!match) {
//                             if (usertype === "manager") {
//                                 // managers must match
//                                 alert(
//                                   "Service provider not available. Please contact the service provider to confirm the correct name. " +
//                                   "If you are the service provider, please register as a General Manager, create your company profile, " +
//                                   "and add managers afterward."
//                                 );
//                                 return;
//                             } else if (input) {
//                                 // clients typed something invalid—warn, but proceed
//                                 alert(
//                                   "Service provider not available. Please contact the service provider to confirm the correct name. " +
//                                   "If none exists, leave it blank and we will assist with assigning one."
//                                );
//                             }
//                             // for clients with blank or invalid input, we simply send no SP fields
//                         } else {
//                             // only attach when there's an exact match
//                             payload.criteria = {
//                                ...(payload.criteria || {}),
//                                 serviceProvider: [match._id]
//                             };
//                             payload.serviceProviders = [{
//                                _id: match._id,
//                                 name: match.companyName
//                             }];
//                         }
//                     }



//         // For General Manager, use the Company Name input to register the service provider.
//         else if (usertype === "general manager") {
//             payload.companyName = companyName;
//             // If no service provider selected, handle new service provider creation flow.
//             if (!selectedServiceProviderId) {
//                 if (!confirmSPCreation) {
//                     setMessage("The company you entered will be registered as the service provider.");
//                     setConfirmSPCreation(true);
//                     return;
//                 }
//                 // --- General Manager SP Creation Flow ---
//                 try {
//                     // Step A: Sign up the GM to get a valid id.
//                     const userResponse = await fetch(`${backendUrl}/signup`, {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(payload),
//                     });
//                     const userData = await userResponse.json();
//                     if (!userResponse.ok || !userData.user || !userData.user.id) {
//                         setMessage(userData.message || "General manager signup failed.");
//                         return;
//                     }
//                     // Add createdBy to payload for SP creation.
//                     payload.createdBy = userData.user.id;

//                     // Step B: Create the service provider.
//                     setIsCreatingServiceProvider(true);
//                     const spPayload = {
//                         companyName,
//                         address: getAddressPayload(),
//                         email,
//                         phone: phoneNumber,
//                         representativeName: effectiveName,
//                         representativePosition: position,
//                         createdBy: payload.createdBy,
//                     };
//                     const spResponse = await fetch(`${backendUrl}/service-providers`, {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(spPayload),
//                     });
//                     const spData = await spResponse.json();
//                     if (!spResponse.ok) {
//                         setMessage(spData.message || "Service provider creation failed.");
//                         setIsCreatingServiceProvider(false);
//                         return;
//                     }
//                     // Create a new service provider object.
//                     const newSP = {
//                         _id: spData.serviceProvider._id.toString(),
//                         name: spData.serviceProvider.companyName,
//                     };

//                     // IMPORTANT: Set the serviceProviders field and prepare the criteria update.
//                     payload.serviceProviders = [newSP];
//                     payload.criteria = { serviceProvider: [newSP] };

//                     // Step C: Update the GM's user record by setting serviceProviders and appending
//                     // the new service provider to criteria.serviceProvider.
//                     const patchResponse = await fetch(`${backendUrl}/user/${payload.createdBy}`, {
//                         method: 'PATCH',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify({
//                             // $set: { serviceProviders: payload.serviceProviders },
//                             // // Use $push with $each to append to the criteria.serviceProvider array.
//                             // $push: { "criteria.serviceProvider": { $each: payload.criteria.serviceProvider } }
//                                  $set: {
//           serviceProviders: payload.serviceProviders,
//           // Map the service provider objects to their _id values so that the criteria field only gets valid Company ObjectIds.
//           "criteria.serviceProvider": payload.serviceProviders.map(sp => sp._id)
//       }
//                         }),
//                     });
//                     let patchData = {};
//                     try {
//                         patchData = await patchResponse.json();
//                     } catch (err) {
//                         console.warn("PATCH response is not valid JSON.", err);
//                     }
//                     if (!patchResponse.ok) {
//                         setMessage(patchData.message || "Failed to update user with new service provider.");
//                         setIsCreatingServiceProvider(false);
//                         return;
//                     }
//                     setIsCreatingServiceProvider(false);
//                     setMessage("Signup successful!");
//                     return; // Exit so that the final signup call is not executed.
//                 } catch (error) {
//                     setMessage("Error creating service provider: " + error.message);
//                     setIsCreatingServiceProvider(false);
//                     return;
//                 }
//             } else {
//                 // If an existing service provider is selected, use it.
//                 const sp = serviceProviders.find(
//                     (sp) => sp._id.toString() === selectedServiceProviderId
//                 );
//                 if (sp) {
//                     payload.serviceProviders = [{
//                         _id: sp._id.toString(),
//                         name: sp.companyName
//                     }];
//                 }
//             }
//         }

//         // For client and manager, send an email confirmation.
//         if (usertype === "client" || usertype === "manager") {
//             if (!email.trim()) {
//                 setMessage("Email is required for registration.");
//                 return;
//             }
//             const userNameForEmail = effectiveName;
//             const emailResponse = await sendEmail(email, userNameForEmail, payload.password);
//             if (typeof emailResponse === "string" && emailResponse.startsWith("Error:")) {
//                 setMessage("Registration failed: " + emailResponse);
//                 return;
//             }
//         }

//         // Clear any properties that might be left from other flows.
//         if (usertype !== "subcontractor" && payload.criteria) {
//             delete payload.criteria;
//         }

//         // Generic signup call for client, manager, subcontractor or general managers with SP selected.
//         try {
//             const response = await fetch(`${backendUrl}/signup`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(payload),
//             });
//             const data = await response.json();
//             if (!response.ok) {
//                 setMessage(data.message || "Signup failed.");
//             } else {
//                 // setMessage("Signup successful!");
//                                updateUser(data.user);    // New
//                 navigate('/dashboard');  // New   
//             }
//         } catch (error) {
//             setMessage("Error during signup: " + error.message);
//         }
//     };

//     return (
//         <Paper className={classes.formContainer}>
//             <Typography variant="h5" gutterBottom align="center">Sign Up</Typography>
//             <form onSubmit={handleSignup}>
//                 <FormControl variant="outlined" className={classes.formField}>
//                     <InputLabel>User Type</InputLabel>
//                     <Select
//                         label="User Type"
//                         value={usertype}
//                         onChange={(e) => {
//                             const value = e.target.value;
//                             setUsertype(value);
//                             // Reset state when changing types.
//                             setAddressDetails({
//                                 building: "",
//                                 apt: "",
//                                 city: "",
//                                 state: "",
//                                 zip: "",
//                                 lat: null,
//                                 lon: null,
//                             });
//                             setShowAddressFields(false);
//                             setSelectedServiceProviderId("");
//                             setCompanyName("");
//                             setServiceProvider(null);
//                             setConfirmSPCreation(false);
//                             setMessage("");
//                         }}
//                     >
//                         <MenuItem value="client">Client / Owner</MenuItem>
//                         <MenuItem value="general manager">General Manager</MenuItem>
//                         <MenuItem value="manager">Manager</MenuItem>
//                         <MenuItem value="tasker">Tasker / Dispatcher</MenuItem>
//                         <MenuItem value="subcontractor">Subcontractor / Implementer</MenuItem>
//                     </Select>
//                 </FormControl>

//                 <TextField
//                     label="Username"
//                     variant="outlined"
//                     className={classes.formField}
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                     required
//                 />
//                 <TextField
//                     label="Email"
//                     variant="outlined"
//                     className={classes.formField}
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                 />
//                 <TextField
//                     label="Password (min 8 characters)"
//                     variant="outlined"
//                     className={classes.formField}
//                     type="password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                     inputProps={{ minLength: 8 }}
//                 />

//                 {/* For client and manager, render the Service Provider dropdown */}
//                 {/* {(["client", "manager"].includes(usertype)) && (
//                     <FormControl variant="outlined" className={classes.formField} required={usertype === "manager"}>
//                         <InputLabel>Service Provider</InputLabel>
//                         <Select
//                             value={selectedServiceProviderId}
//                             onChange={(e) => {
//                                 const id = e.target.value;
//                                 setSelectedServiceProviderId(id);
//                                 const sp = serviceProviders.find(sp => sp._id.toString() === id);
//                                 setServiceProvider(sp ? { _id: id, name: sp.companyName } : null);
//                                 if (id) setConfirmSPCreation(false);
//                             }}
//                             label="Service Provider"
//                         >
//                             <MenuItem value="">
//                                 <em>Select a service provider</em>
//                             </MenuItem>
//                             {serviceProviders.map((sp) => (
//                                 <MenuItem key={sp._id} value={sp._id.toString()}>
//                                     {sp.companyName}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 )} */}

//                 {/* {(["client","manager"].includes(usertype)) && (
//                     <TextField
//                         label="Service Provider"
//                         variant="outlined"
//                         className={classes.formField}
//                         value={serviceProviderInput}
//                         onChange={e => setServiceProviderInput(e.target.value)}
//                         required
//                         helperText="Type the exact name of your Service Provider"
//                     />
//                 )} */}
//  {/* {["client","manager"].includes(usertype) && (
//                     <TextField
//                         label="Service Provider"
//                         variant="outlined"
//                         className={classes.formField}
//                         value={serviceProviderInput}
//                         onChange={e => setServiceProviderInput(e.target.value)}
//                         required={usertype === "manager"}
//                         helperText={
//                             usertype === "manager"
//                                 ? "Type the exact name of your Service Provider"
//                                 : "(optional)"
//                         }
//                     />
//                 )} */}


// {["client","manager"].includes(usertype) && (
//                     <TextField
//                         label="Service Provider"
//                        variant="outlined"
//                         className={classes.formField}
//                         value={serviceProviderInput}
//                         onChange={e => setServiceProviderInput(e.target.value)}
//                         // only enforce required HTML-validation for managers
//                         required={usertype === "manager"}
//                         helperText={
//                             usertype === "manager"
//                                 ? "Type the exact name of your Service Provider"
//                                 : "(optional)"
//                         }
//                     />
//                 )}


//                 {/* For General Manager, render the Company Name and extra fields */}
//                 {usertype === "general manager" && (
//                     <>
//                         <TextField
//                             label="Company Name"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={companyName}
//                             onChange={(e) => setCompanyName(e.target.value)}
//                             required
//                         />
//                         <TextField
//                             label="Name"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={name}
//                             onChange={(e) => setName(e.target.value)}
//                             required
//                         />
//                         <div className={classes.formField}>
//                             <AddressCheck onAddressSelect={setAddressDetails} />
//                         </div>
//                         <TextField
//                             label="Position"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={position}
//                             onChange={(e) => setPosition(e.target.value)}
//                             required
//                         />
//                         <TextField
//                             label="Phone Number (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={phoneNumber}
//                             onChange={(e) => setPhoneNumber(e.target.value)}
//                         />
//                     </>
//                 )}

//                 {/* For Subcontractor, render the Tasker / Dispatcher input */}
//                 {usertype === "subcontractor" && (
//                     <TextField
//                         label="Tasker / Dispatcher"
//                         variant="outlined"
//                         className={classes.formField}
//                         value={taskerInput}
//                         onChange={(e) => setTaskerInput(e.target.value)}
//                         required
//                     />
//                 )}

//                 <Button
//                     variant="outlined"
//                     onClick={() => setShowAddressFields(!showAddressFields)}
//                     className={classes.formField}
//                 >
//                     {showAddressFields ? "Hide Address / Operation Area" : "Add Address / Operation Area"}
//                 </Button>

//                 {showAddressFields && (
//                     <>
//                         <div className={classes.formField}>
//                             <AddressCheck
//                                 placeholder="Building Address (optional)"
//                                 label="Building Address (optional)"
//                                 onAddressSelect={setAddressDetails}
//                             />
//                         </div>
//                         <TextField
//                             label="City (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={addressDetails.city}
//                             onChange={(e) =>
//                                 setAddressDetails({ ...addressDetails, city: e.target.value })
//                             }
//                         />
//                         <TextField
//                             label="State (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={addressDetails.state}
//                             onChange={(e) =>
//                                 setAddressDetails({ ...addressDetails, state: e.target.value })
//                             }
//                         />
//                         <TextField
//                             label="Zip Code (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={addressDetails.zip}
//                             onChange={(e) =>
//                                 setAddressDetails({ ...addressDetails, zip: e.target.value })
//                             }
//                         />
//                         <TextField
//                             label="Apt/Suite (optional)"
//                             placeholder="Apt/Suite (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={addressDetails.apt}
//                             onChange={(e) =>
//                                 setAddressDetails({ ...addressDetails, apt: e.target.value })
//                             }
//                         />
//                     </>
//                 )}

//                 <Button
//                     type="submit"
//                     variant="contained"
//                     className={classes.submitButton}
//                     disabled={isCreatingServiceProvider}
//                 >
//                     Sign Up
//                 </Button>
//             </form>
//             {message && (
//                 <Typography
//                     variant="body2"
//                     align="center"
//                     style={{ marginTop: 16, fontSize: '0.85rem', color: confirmSPCreation ? '#4b9ef1' : undefined }}
//                 >
//                     {message}
//                 </Typography>
//             )}
//         </Paper>
//     );
// };

// export default Signup;












// import React, { useState, useEffect, useContext } from 'react'; 
// import { useNavigate } from 'react-router-dom'; 
// import { UserContext } from './userContext';  
// import {
//     Paper,
//     Typography,
//     TextField,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     Button,
// } from '@mui/material';
// import { makeStyles } from '@mui/styles';
// import { backendUrl } from './config';
// import AddressCheck from './checkAddress';
// import { sendEmail } from './sendEmail';

// const useStyles = makeStyles(() => ({
//     formContainer: {
//         padding: 32,
//         maxWidth: 400,
//         margin: 'auto',
//         backgroundColor: '#fff',
//         boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
//         borderRadius: 8,
//     },
//     formField: {
//         marginBottom: '3px !important',
//         width: '100%',
//     },
//     submitButton: {
//         marginTop: 16,
//         width: '100%',
//         display: 'block',
//         backgroundColor: '#4b9ef1 !important',
//         color: '#fff !important',
//     },
// }));

// const Signup = () => {
//     const classes = useStyles();
//     const { updateUser } = useContext(UserContext);  // new
//     const navigate = useNavigate();   // New

//     const [usertype, setUsertype] = useState("client");
//     const [username, setUsername] = useState("");
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const [name, setName] = useState("");
//     const [companyName, setCompanyName] = useState("");
//     const [position, setPosition] = useState("");
//     const [phoneNumber, setPhoneNumber] = useState("");
//     const [serviceProvider, setServiceProvider] = useState(null);

//     const [message, setMessage] = useState("");
//     const [confirmSPCreation, setConfirmSPCreation] = useState(false);
//     const [isCreatingServiceProvider, setIsCreatingServiceProvider] = useState(false);

//     const [addressDetails, setAddressDetails] = useState({
//         building: "",
//         apt: "",
//         city: "",
//         state: "",
//         zip: "",
//         lat: null,
//         lon: null,
//     });

//     const [showAddressFields, setShowAddressFields] = useState(false);
//     // const [serviceProviders, setServiceProviders] = useState([]);
//     const [selectedServiceProviderId, setSelectedServiceProviderId] = useState("");
//     const [serviceProviderInput, setServiceProviderInput] = useState("");
//     const [serviceProviders, setServiceProviders] = useState([]);  // still fetch list for lookup


//     // NEW: State for Tasker / Dispatcher input and fetched taskers
//     const [taskerInput, setTaskerInput] = useState("");
//     const [taskers, setTaskers] = useState([]);

//     useEffect(() => {
//         // For client and manager, fetch available service providers
//         if (["client", "manager", "tasker"].includes(usertype)) {
//             async function fetchServiceProviders() {
//                 try {
//                     const res = await fetch(`${backendUrl}/service-providers`);
//                     if (!res.ok) throw new Error("Failed to fetch service providers");
//                     const data = await res.json();
//                     setServiceProviders(data);
//                     if (usertype === "client" && data.length > 0) {
//                         const sp = data[0];
//                         const spId = sp._id.toString();
//                         setSelectedServiceProviderId(spId);
//                         setServiceProvider({ _id: spId, name: sp.companyName });
//                     }
//                 } catch (err) {
//                     console.error(err);
//                 }
//             }
//             fetchServiceProviders();
//         }
//     }, [usertype]);

//     // Fetch taskers when usertype is subcontractor (implementer)
//     useEffect(() => {
//         if (usertype === "subcontractor") {
//             async function fetchTaskers() {
//                 try {
//                     const res = await fetch(`${backendUrl}/taskers`);
//                     if (!res.ok) throw new Error("Failed to fetch taskers");
//                     const data = await res.json();
//                     setTaskers(data);
//                 } catch (err) {
//                     console.error(err);
//                 }
//             }
//             fetchTaskers();
//         }
//     }, [usertype]);

//     const getAddressPayload = () => ({
//         ...addressDetails,
//         apt: addressDetails.apt || "",
//     });

//     const handleSignup = async (e) => {
//         e.preventDefault();

//         // Clear any previous confirmations if reselecting a user type.
//         if (confirmSPCreation && selectedServiceProviderId) {
//             setConfirmSPCreation(false);
//         }

//         if (password.length < 8) {
//             setMessage("Password must be at least 8 characters long.");
//             return;
//         }

//         // Use "implementer" internally for subcontractor
//         const effectiveUserType = usertype === "subcontractor" ? "implementer" : usertype;
//         const effectiveName = usertype === "client" ? username : (name.trim() ? name.trim() : email.trim());

//         // Build the base payload for all user types
//         const payload = {
//             usertype: effectiveUserType,
//             accountSource: 'otherFrontend',    
//             username,
//             email,
//             password,
//             name: effectiveName,
//             position,
//             phoneNumber,
//             address: getAddressPayload(),
//         };
//             if (effectiveUserType === "implementer") {
//     if (taskerInput.trim()) {
//         let currentTaskers = taskers;
//         try {
//             const res = await fetch(`${backendUrl}/taskers`);
//             if (!res.ok) throw new Error("Failed to fetch taskers");
//             currentTaskers = await res.json();
//             setTaskers(currentTaskers);
//         } catch (error) {
//             console.error("Error fetching taskers:", error);
//             currentTaskers = [];
//         }
//         const matchedTasker = currentTaskers.find((t) => t.username === taskerInput);
//         payload.criteria = { tasker: matchedTasker ? [matchedTasker._id] : [] };
//     } else {
//         payload.criteria = { tasker: [] };
//     }
// }
//         if (["client","manager"].includes(usertype)) {
//                         const input = serviceProviderInput.trim();
//                        const match = serviceProviders.find(
//                             sp => sp.companyName.toLowerCase() === input.toLowerCase()
//                         );
            
//                         if (!match) {
//                             if (usertype === "manager") {
//                                 alert(
//                                   "Service provider not available. Please contact the service provider to confirm the correct name. " +
//                                   "If you are the service provider, please register as a General Manager, create your company profile, " +
//                                   "and add managers afterward."
//                                 );
//                                 return;
//                             } else if (input) {
//                                 alert(
//                                   "Service provider not available. Please contact the service provider to confirm the correct name. " +
//                                   "If none exists, leave it blank and we will assist with assigning one."
//                                );
//                             }
//                         } else {
//                             payload.criteria = {
//                                ...(payload.criteria || {}),
//                                 serviceProvider: [match._id]
//                             };
//                             payload.serviceProviders = [{
//                                _id: match._id,
//                                 name: match.companyName
//                             }];
//                         }
//                     }



//         // For General Manager, use the Company Name input to register the service provider.
//         else if (usertype === "general manager") {
//             payload.companyName = companyName;
//             // If no service provider selected, handle new service provider creation flow.
//             if (!selectedServiceProviderId) {
//                 if (!confirmSPCreation) {
//                     setMessage("The company you entered will be registered as the service provider.");
//                     setConfirmSPCreation(true);
//                     return;
//                 }
//                 // --- General Manager SP Creation Flow ---
//                 try {
//                     // Step A: Sign up the GM to get a valid id.
//                     const userResponse = await fetch(`${backendUrl}/signup`, {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(payload),
//                     });
//                     const userData = await userResponse.json();
//                     if (!userResponse.ok || !userData.user || !userData.user.id) {
//                         setMessage(userData.message || "General manager signup failed.");
//                         return;
//                     }
//                     // Add createdBy to payload for SP creation.
//                     payload.createdBy = userData.user.id;

//                     // Step B: Create the service provider.
//                     setIsCreatingServiceProvider(true);
//                     const spPayload = {
//                         companyName,
//                         address: getAddressPayload(),
//                         email,
//                         phone: phoneNumber,
//                         representativeName: effectiveName,
//                         representativePosition: position,
//                         createdBy: payload.createdBy,
//                     };
//                     const spResponse = await fetch(`${backendUrl}/service-providers`, {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify(spPayload),
//                     });
//                     const spData = await spResponse.json();
//                     if (!spResponse.ok) {
//                         setMessage(spData.message || "Service provider creation failed.");
//                         setIsCreatingServiceProvider(false);
//                         return;
//                     }
//                     const newSP = {
//                         _id: spData.serviceProvider._id.toString(),
//                         name: spData.serviceProvider.companyName,
//                     };

//                     payload.serviceProviders = [newSP];
//                     payload.criteria = { serviceProvider: [newSP] };

//                     const patchResponse = await fetch(`${backendUrl}/user/${payload.createdBy}`, {
//                         method: 'PATCH',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify({
//                                  $set: {
//           serviceProviders: payload.serviceProviders,
//           "criteria.serviceProvider": payload.serviceProviders.map(sp => sp._id)
//       }
//                         }),
//                     });
//                     let patchData = {};
//                     try {
//                         patchData = await patchResponse.json();
//                     } catch (err) {
//                         console.warn("PATCH response is not valid JSON.", err);
//                     }
//                     if (!patchResponse.ok) {
//                         setMessage(patchData.message || "Failed to update user with new service provider.");
//                         setIsCreatingServiceProvider(false);
//                         return;
//                     }
//                     setIsCreatingServiceProvider(false);
//                     setMessage("Signup successful!");
//                     return; // Exit so that the final signup call is not executed.
//                 } catch (error) {
//                     setMessage("Error creating service provider: " + error.message);
//                     setIsCreatingServiceProvider(false);
//                     return;
//                 }
//             } else {
//                 // If an existing service provider is selected, use it.
//                 const sp = serviceProviders.find(
//                     (sp) => sp._id.toString() === selectedServiceProviderId
//                 );
//                 if (sp) {
//                     payload.serviceProviders = [{
//                         _id: sp._id.toString(),
//                         name: sp.companyName
//                     }];
//                 }
//             }
//         }

//         else if (usertype === "tasker") {
//             const input = serviceProviderInput.trim();
//             const match = serviceProviders.find(
//                 sp => sp.companyName.toLowerCase() === input.toLowerCase()
//             );
//             if (!match) {
//                 setMessage(
//                   "Selected service provider does not exist or does not accept new taskers."
//                 );
//                 return;
//             }
//             payload.criteria = {
//                ...(payload.criteria || {}),
//                serviceProvider: [match._id]
//             };
//             payload.serviceProviders = [{
//                _id: match._id,
//                name: match.companyName
//             }];
//         }

//         // For client and manager, send an email confirmation.
//         if (usertype === "client" || usertype === "manager") {
//             if (!email.trim()) {
//                 setMessage("Email is required for registration.");
//                 return;
//             }
//             const userNameForEmail = effectiveName;
//             const emailResponse = await sendEmail(email, userNameForEmail, payload.password);
//             if (typeof emailResponse === "string" && emailResponse.startsWith("Error:")) {
//                 setMessage("Registration failed: " + emailResponse);
//                 return;
//             }
//         }
//         if (usertype !== "subcontractor" && payload.criteria) {
//             delete payload.criteria;
//         }
//           try {
//             const response = await fetch(`${backendUrl}/signup`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 credentials: 'include',
//                 body: JSON.stringify(payload),
//             });
//             const data = await response.json();
//             if (!response.ok) {
//                 setMessage(data.message || "Signup failed.");
//                 return;
//             }

//             let finalUser = data.user;

//             if (usertype === "tasker") {
//                 const patchRes = await fetch(
//                   `${backendUrl}/user/${finalUser.id}`, 
//                   {
//                     method: 'PATCH',
//                     credentials: 'include',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({
//                       serviceProviders: payload.serviceProviders,
//                       criteria: {
//                         ...(finalUser.criteria || {}),
//                         serviceProvider: payload.serviceProviders.map(sp => sp._id),
//                       }
//                     }),
//                   }
//                 );
//                 const patchData = await patchRes.json();
//                 if (patchRes.ok) {
//                   finalUser = patchData.user || patchData;
//                 }
//             }

//             // 3) Update context and navigate
//             updateUser(finalUser);
//             navigate('/dashboard');
//         } catch (error) {
//             setMessage("Error during signup: " + error.message);
//         }
//     };

//     return (
//         <Paper className={classes.formContainer}>
//             <Typography variant="h5" gutterBottom align="center">Sign Up</Typography>
//             <form onSubmit={handleSignup}>
//                 <FormControl variant="outlined" className={classes.formField}>
//                     <InputLabel>User Type</InputLabel>
//                     <Select
//                         label="User Type"
//                         value={usertype}
//                         onChange={(e) => {
//                             const value = e.target.value;
//                             setUsertype(value);
//                             // Reset state when changing types.
//                             setAddressDetails({
//                                 building: "",
//                                 apt: "",
//                                 city: "",
//                                 state: "",
//                                 zip: "",
//                                 lat: null,
//                                 lon: null,
//                             });
//                             setShowAddressFields(false);
//                             setSelectedServiceProviderId("");
//                             setCompanyName("");
//                             setServiceProvider(null);
//                             setConfirmSPCreation(false);
//                             setMessage("");
//                         }}
//                     >
//                         <MenuItem value="client">Client / Owner</MenuItem>
//                         <MenuItem value="general manager">General Manager</MenuItem>
//                         <MenuItem value="manager">Manager</MenuItem>
//                         <MenuItem value="tasker">Tasker / Dispatcher</MenuItem>
//                         <MenuItem value="subcontractor">Subcontractor / Implementer</MenuItem>
//                     </Select>
//                 </FormControl>

//                 <TextField
//                     label="Username"
//                     variant="outlined"
//                     className={classes.formField}
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                     required
//                 />
//                 <TextField
//                     label="Email"
//                     variant="outlined"
//                     className={classes.formField}
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                 />
//                 <TextField
//                     label="Password (min 8 characters)"
//                     variant="outlined"
//                     className={classes.formField}
//                     type="password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                     inputProps={{ minLength: 8 }}
//                 />

// {["client","manager"].includes(usertype) && (
//                     <TextField
//                         label="Service Provider"
//                        variant="outlined"
//                         className={classes.formField}
//                         value={serviceProviderInput}
//                         onChange={e => setServiceProviderInput(e.target.value)}
//                         // only enforce required HTML-validation for managers
//                         required={usertype === "manager"}
//                         helperText={
//                             usertype === "manager"
//                                 ? "Type the exact name of your Service Provider"
//                                 : "(optional)"
//                         }
//                     />
//                 )}

//                 {/* For General Manager, render the Company Name and extra fields */}
//                 {usertype === "general manager" && (
//                     <>
//                         <TextField
//                             label="Company Name"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={companyName}
//                             onChange={(e) => setCompanyName(e.target.value)}
//                             required
//                         />
//                         <TextField
//                             label="Name"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={name}
//                             onChange={(e) => setName(e.target.value)}
//                             required
//                         />
//                         <div className={classes.formField}>
//                             <AddressCheck onAddressSelect={setAddressDetails} />
//                         </div>
//                         <TextField
//                             label="Position"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={position}
//                             onChange={(e) => setPosition(e.target.value)}
//                             required
//                         />
//                         <TextField
//                             label="Phone Number (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={phoneNumber}
//                             onChange={(e) => setPhoneNumber(e.target.value)}
//                         />
//                     </>
//                 )}

//                 {/* For Subcontractor, render the Tasker / Dispatcher input */}
//                 {usertype === "subcontractor" && (
//                     <TextField
//                         label="Tasker / Dispatcher"
//                         variant="outlined"
//                         className={classes.formField}
//                         value={taskerInput}
//                         onChange={(e) => setTaskerInput(e.target.value)}
//                         required
//                     />
//                 )}

//                 {usertype === "tasker" && (
//                     <TextField
//                         label="Service Provider"
//                         variant="outlined"
//                         className={classes.formField}
//                         value={serviceProviderInput}
//                         onChange={e => setServiceProviderInput(e.target.value)}
//                         required
//                         helperText="Type exact name of your Service Provider"
//                     />
//                 )}

//                 <Button
//                     variant="outlined"
//                     onClick={() => setShowAddressFields(!showAddressFields)}
//                     className={classes.formField}
//                 >
//                     {showAddressFields ? "Hide Address / Operation Area" : "Add Address / Operation Area"}
//                 </Button>

//                 {showAddressFields && (
//                     <>
//                         <div className={classes.formField}>
//                             <AddressCheck
//                                 placeholder="Building Address (optional)"
//                                 label="Building Address (optional)"
//                                 onAddressSelect={setAddressDetails}
//                             />
//                         </div>
//                         <TextField
//                             label="City (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={addressDetails.city}
//                             onChange={(e) =>
//                                 setAddressDetails({ ...addressDetails, city: e.target.value })
//                             }
//                         />
//                         <TextField
//                             label="State (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={addressDetails.state}
//                             onChange={(e) =>
//                                 setAddressDetails({ ...addressDetails, state: e.target.value })
//                             }
//                         />
//                         <TextField
//                             label="Zip Code (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={addressDetails.zip}
//                             onChange={(e) =>
//                                 setAddressDetails({ ...addressDetails, zip: e.target.value })
//                             }
//                         />
//                         <TextField
//                             label="Apt/Suite (optional)"
//                             placeholder="Apt/Suite (optional)"
//                             variant="outlined"
//                             className={classes.formField}
//                             value={addressDetails.apt}
//                             onChange={(e) =>
//                                 setAddressDetails({ ...addressDetails, apt: e.target.value })
//                             }
//                         />
//                     </>
//                 )}

//                 <Button
//                     type="submit"
//                     variant="contained"
//                     className={classes.submitButton}
//                     disabled={isCreatingServiceProvider}
//                 >
//                     Sign Up
//                 </Button>
//             </form>
//             {message && (
//                 <Typography
//                     variant="body2"
//                     align="center"
//                     style={{ marginTop: 16, fontSize: '0.85rem', color: confirmSPCreation ? '#4b9ef1' : undefined }}
//                 >
//                     {message}
//                 </Typography>
//             )}
//         </Paper>
//     );
// };

// export default Signup;











// components/signup.jsx
import React, { useState, useEffect, useContext } from 'react'; 
import { useNavigate } from 'react-router-dom'; 
import { UserContext } from './userContext';  
import {
    Paper,
    Typography,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { backendUrl } from './config';
import AddressCheck from './checkAddress';
import { sendEmail } from './sendEmail';

const useStyles = makeStyles(() => ({
    formContainer: {
        padding: 32,
        maxWidth: 400,
        margin: 'auto',
        backgroundColor: '#fff',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
        borderRadius: 8,
    },
    formField: {
        marginBottom: '3px !important',
        width: '100%',
    },
    submitButton: {
        marginTop: 16,
        width: '100%',
        display: 'block',
        backgroundColor: '#4b9ef1 !important',
        color: '#fff !important',
    },
}));

const Signup = () => {
    const classes = useStyles();
    const { updateUser } = useContext(UserContext);  // new
    const navigate = useNavigate();   // New

    const [usertype, setUsertype] = useState("client");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [position, setPosition] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [serviceProvider, setServiceProvider] = useState(null);

    const [message, setMessage] = useState("");
    const [confirmSPCreation, setConfirmSPCreation] = useState(false);
    const [isCreatingServiceProvider, setIsCreatingServiceProvider] = useState(false);

    const [addressDetails, setAddressDetails] = useState({
        building: "",
        apt: "",
        city: "",
        state: "",
        zip: "",
        lat: null,
        lon: null,
    });

    const [showAddressFields, setShowAddressFields] = useState(false);
    // const [serviceProviders, setServiceProviders] = useState([]);
    const [selectedServiceProviderId, setSelectedServiceProviderId] = useState("");
    const [serviceProviderInput, setServiceProviderInput] = useState("");
    const [serviceProviders, setServiceProviders] = useState([]);  // still fetch list for lookup


    // NEW: State for Tasker / Dispatcher input and fetched taskers
    const [taskerInput, setTaskerInput] = useState("");
    const [taskers, setTaskers] = useState([]);

    useEffect(() => {
        // For client and manager, fetch available service providers
        if (["client", "manager", "tasker"].includes(usertype)) {
            async function fetchServiceProviders() {
                try {
                    const res = await fetch(`${backendUrl}/service-providers`);
                    if (!res.ok) throw new Error("Failed to fetch service providers");
                    const data = await res.json();
                    setServiceProviders(data);
                    if (usertype === "client" && data.length > 0) {
                        const sp = data[0];
                        const spId = sp._id.toString();
                        setSelectedServiceProviderId(spId);
                        setServiceProvider({ _id: spId, name: sp.companyName });
                    }
                } catch (err) {
                    console.error(err);
                }
            }
            fetchServiceProviders();
        }
    }, [usertype]);

    // Fetch taskers when usertype is subcontractor (implementer)
    useEffect(() => {
        if (usertype === "subcontractor") {
            async function fetchTaskers() {
                try {
                    const res = await fetch(`${backendUrl}/taskers`);
                    if (!res.ok) throw new Error("Failed to fetch taskers");
                    const data = await res.json();
                    setTaskers(data);
                } catch (err) {
                    console.error(err);
                }
            }
            fetchTaskers();
        }
    }, [usertype]);

    const getAddressPayload = () => ({
        ...addressDetails,
        apt: addressDetails.apt || "",
    });

    const handleSignup = async (e) => {
        e.preventDefault();

        // Clear any previous confirmations if reselecting a user type.
        if (confirmSPCreation && selectedServiceProviderId) {
            setConfirmSPCreation(false);
        }

        if (password.length < 8) {
            setMessage("Password must be at least 8 characters long.");
            return;
        }

        // Use "implementer" internally for subcontractor
        const effectiveUserType = usertype === "subcontractor" ? "implementer" : usertype;
        const effectiveName = usertype === "client" ? username : (name.trim() ? name.trim() : email.trim());

        // Build the base payload for all user types
        const payload = {
            usertype: effectiveUserType,
            accountSource: 'otherFrontend',    
            username,
            email,
            password,
            name: effectiveName,
            position,
            phoneNumber,
            address: getAddressPayload(),
        };
            if (effectiveUserType === "implementer") {
    if (taskerInput.trim()) {
        let currentTaskers = taskers;
        try {
            const res = await fetch(`${backendUrl}/taskers`);
            if (!res.ok) throw new Error("Failed to fetch taskers");
            currentTaskers = await res.json();
            setTaskers(currentTaskers);
        } catch (error) {
            console.error("Error fetching taskers:", error);
            currentTaskers = [];
        }
        const matchedTasker = currentTaskers.find((t) => t.username === taskerInput);
        payload.criteria = { tasker: matchedTasker ? [matchedTasker._id] : [] };
    } else {
        payload.criteria = { tasker: [] };
    }
}
        if (["client","manager"].includes(usertype)) {
                        const input = serviceProviderInput.trim();
                       const match = serviceProviders.find(
                            sp => sp.companyName.toLowerCase() === input.toLowerCase()
                        );
            
                        if (!match) {
                            if (usertype === "manager") {
                                alert(
                                  "Service provider not available. Please contact the service provider to confirm the correct name. " +
                                  "If you are the service provider, please register as a General Manager, create your company profile, " +
                                  "and add managers afterward."
                                );
                                return;
                            } else if (input) {
                                alert(
                                  "Service provider not available. Please contact the service provider to confirm the correct name. " +
                                  "If none exists, leave it blank and we will assist with assigning one."
                               );
                            }
                        } else {
                            payload.criteria = {
                               ...(payload.criteria || {}),
                                serviceProvider: [match._id]
                            };
                            payload.serviceProviders = [{
                               _id: match._id,
                                name: match.companyName
                            }];
                        }
                    }



        // For General Manager, use the Company Name input to register the service provider.
        else if (usertype === "general manager") {
            payload.companyName = companyName;
            // If no service provider selected, handle new service provider creation flow.
            if (!selectedServiceProviderId) {
                if (!confirmSPCreation) {
                    setMessage("The company you entered will be registered as the service provider.");
                    setConfirmSPCreation(true);
                    return;
                }
                // --- General Manager SP Creation Flow ---
                try {
                    // Step A: Sign up the GM to get a valid id.
                    const userResponse = await fetch(`${backendUrl}/signup`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload),
                    });
                    const userData = await userResponse.json();
                    if (!userResponse.ok || !userData.user || !userData.user.id) {
                        setMessage(userData.message || "General manager signup failed.");
                        return;
                    }
                    // Add createdBy to payload for SP creation.
                    payload.createdBy = userData.user.id;

                    // Step B: Create the service provider.
                    setIsCreatingServiceProvider(true);
                    const spPayload = {
                        companyName,
                        address: getAddressPayload(),
                        email,
                        phone: phoneNumber,
                        representativeName: effectiveName,
                        representativePosition: position,
                        createdBy: payload.createdBy,
                    };
                    const spResponse = await fetch(`${backendUrl}/service-providers`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(spPayload),
                    });
                    const spData = await spResponse.json();
                    if (!spResponse.ok) {
                        setMessage(spData.message || "Service provider creation failed.");
                        setIsCreatingServiceProvider(false);
                        return;
                    }
                    const newSP = {
                        _id: spData.serviceProvider._id.toString(),
                        name: spData.serviceProvider.companyName,
                    };

                    payload.serviceProviders = [newSP];
                    payload.criteria = { serviceProvider: [newSP] };

                    const patchResponse = await fetch(`${backendUrl}/user/${payload.createdBy}`, {
                        method: 'PATCH',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                                 $set: {
          serviceProviders: payload.serviceProviders,
          "criteria.serviceProvider": payload.serviceProviders.map(sp => sp._id)
      }
                        }),
                    });
                    let patchData = {};
                    try {
                        patchData = await patchResponse.json();
                    } catch (err) {
                        console.warn("PATCH response is not valid JSON.", err);
                    }
                    if (!patchResponse.ok) {
                        setMessage(patchData.message || "Failed to update user with new service provider.");
                        setIsCreatingServiceProvider(false);
                        return;
                    }
                    setIsCreatingServiceProvider(false);
                    setMessage("Signup successful!");
                    return; // Exit so that the final signup call is not executed.
                } catch (error) {
                    setMessage("Error creating service provider: " + error.message);
                    setIsCreatingServiceProvider(false);
                    return;
                }
            } else {
                // If an existing service provider is selected, use it.
                const sp = serviceProviders.find(
                    (sp) => sp._id.toString() === selectedServiceProviderId
                );
                if (sp) {
                    payload.serviceProviders = [{
                        _id: sp._id.toString(),
                        name: sp.companyName
                    }];
                }
            }
        }

        else if (usertype === "tasker") {
            const input = serviceProviderInput.trim();
            const match = serviceProviders.find(
                sp => sp.companyName.toLowerCase() === input.toLowerCase()
            );
            if (!match) {
                setMessage(
                  "Selected service provider does not exist or does not accept new taskers."
                );
                return;
            }
            payload.criteria = {
               ...(payload.criteria || {}),
               serviceProvider: [match._id]
            };
            payload.serviceProviders = [{
               _id: match._id,
               name: match.companyName
            }];
        }

        // For client and manager, send an email confirmation.
        if (usertype === "client" || usertype === "manager") {
            if (!email.trim()) {
                setMessage("Email is required for registration.");
                return;
            }
            const userNameForEmail = effectiveName;
            const emailResponse = await sendEmail(email, userNameForEmail, payload.password);
            if (typeof emailResponse === "string" && emailResponse.startsWith("Error:")) {
                setMessage("Registration failed: " + emailResponse);
                return;
            }
        }
        if (usertype !== "subcontractor" && payload.criteria) {
            delete payload.criteria;
        }
          try {
            const response = await fetch(`${backendUrl}/signup`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(payload),
            });
            const data = await response.json();
            if (!response.ok) {
                setMessage(data.message || "Signup failed.");
                return;
            }

            let finalUser = data.user;

            if (usertype === "tasker") {
                const patchRes = await fetch(
                  `${backendUrl}/user/${finalUser.id}`, 
                  {
                    method: 'PATCH',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      serviceProviders: payload.serviceProviders,
                      criteria: {
                        ...(finalUser.criteria || {}),
                        serviceProvider: payload.serviceProviders.map(sp => sp._id),
                      }
                    }),
                  }
                );
                const patchData = await patchRes.json();
                if (patchRes.ok) {
                  finalUser = patchData.user || patchData;
                }
            }

            // 3) Update context and navigate
            updateUser(finalUser);
            navigate('/dashboard');
        } catch (error) {
            setMessage("Error during signup: " + error.message);
        }
    };

    return (
        <Paper className={classes.formContainer}>
            <Typography variant="h5" gutterBottom align="center">Sign Up</Typography>
            <form onSubmit={handleSignup}>
                <FormControl variant="outlined" className={classes.formField}>
                    <InputLabel>User Type</InputLabel>
                    <Select
                        label="User Type"
                        value={usertype}
                        onChange={(e) => {
                            const value = e.target.value;
                            setUsertype(value);
                            // Reset state when changing types.
                            setAddressDetails({
                                building: "",
                                apt: "",
                                city: "",
                                state: "",
                                zip: "",
                                lat: null,
                                lon: null,
                            });
                            setShowAddressFields(false);
                            setSelectedServiceProviderId("");
                            setCompanyName("");
                            setServiceProvider(null);
                            setConfirmSPCreation(false);
                            setMessage("");
                        }}
                    >
                        <MenuItem value="client">Client / Owner</MenuItem>
                        <MenuItem value="general manager">General Manager</MenuItem>
                        <MenuItem value="manager">Manager</MenuItem>
                        <MenuItem value="tasker">Tasker / Dispatcher</MenuItem>
                        <MenuItem value="subcontractor">Subcontractor / Implementer</MenuItem>
                    </Select>
                </FormControl>

                <TextField
                    label="Username"
                    variant="outlined"
                    className={classes.formField}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <TextField
                    label="Email"
                    variant="outlined"
                    className={classes.formField}
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <TextField
                    label="Password (min 8 characters)"
                    variant="outlined"
                    className={classes.formField}
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    inputProps={{ minLength: 8 }}
                />

{["client","manager"].includes(usertype) && (
                    <TextField
                        label="Service Provider"
                       variant="outlined"
                        className={classes.formField}
                        value={serviceProviderInput}
                        onChange={e => setServiceProviderInput(e.target.value)}
                        // only enforce required HTML-validation for managers
                        required={usertype === "manager"}
                        helperText={
                            usertype === "manager"
                                ? "Type the exact name of your Service Provider"
                                : "(optional)"
                        }
                    />
                )}

                {/* For General Manager, render the Company Name and extra fields */}
                {usertype === "general manager" && (
                    <>
                        <TextField
                            label="Company Name"
                            variant="outlined"
                            className={classes.formField}
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            required
                        />
                        <TextField
                            label="Name"
                            variant="outlined"
                            className={classes.formField}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
{/*                         <div className={classes.formField}>
                            <AddressCheck onAddressSelect={setAddressDetails} />
                        </div> */}
                        <TextField
                            label="Position"
                            variant="outlined"
                            className={classes.formField}
                            value={position}
                            onChange={(e) => setPosition(e.target.value)}
                            required
                        />
                        <TextField
                            label="Phone Number (optional)"
                            variant="outlined"
                            className={classes.formField}
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                    </>
                )}

                {/* For Subcontractor, render the Tasker / Dispatcher input */}
                {usertype === "subcontractor" && (
                    <TextField
                        label="Tasker / Dispatcher"
                        variant="outlined"
                        className={classes.formField}
                        value={taskerInput}
                        onChange={(e) => setTaskerInput(e.target.value)}
                        required
                    />
                )}

                {usertype === "tasker" && (
                    <TextField
                        label="Service Provider"
                        variant="outlined"
                        className={classes.formField}
                        value={serviceProviderInput}
                        onChange={e => setServiceProviderInput(e.target.value)}
                        required
                        helperText="Type exact name of your Service Provider"
                    />
                )}

                <Button
                    variant="outlined"
                    onClick={() => setShowAddressFields(!showAddressFields)}
                    className={classes.formField}
                >
                    {showAddressFields ? "Hide Address / Operation Area" : "Add Address / Operation Area"}
                </Button>

                {showAddressFields && (
                    <>
                        <div className={classes.formField}>
                            <AddressCheck
                                placeholder="Building Address (optional)"
                                label="Building Address (optional)"
                                onAddressSelect={setAddressDetails}
                            />
                        </div>
                        <TextField
                            label="Apt/Suite (optional)"
                            placeholder="Apt/Suite (optional)"
                            variant="outlined"
                            className={classes.formField}
                            value={addressDetails.apt}
                            onChange={(e) =>
                                setAddressDetails({ ...addressDetails, apt: e.target.value })
                            }
                        />
                    </>
                )}

                <Button
                    type="submit"
                    variant="contained"
                    className={classes.submitButton}
                    disabled={isCreatingServiceProvider}
                >
                    Sign Up
                </Button>
            </form>
            {message && (
                <Typography
                    variant="body2"
                    align="center"
                    style={{ marginTop: 16, fontSize: '0.85rem', color: confirmSPCreation ? '#4b9ef1' : undefined }}
                >
                    {message}
                </Typography>
            )}
        </Paper>
    );
};

export default Signup;



























